import React from "react";
import { BackgroundWrapper } from "./styled";

function Background() {
  return <BackgroundWrapper />;
}

export default Background;
